import { render, staticRenderFns } from "./treatpack-dialog-selector.vue?vue&type=template&id=e821775a&"
import script from "./treatpack-dialog-selector.vue?vue&type=script&lang=js&"
export * from "./treatpack-dialog-selector.vue?vue&type=script&lang=js&"
import style0 from "./treatpack-dialog-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports